import { render, staticRenderFns } from "./CreateNewEmployeeForm.vue?vue&type=template&id=852f32ae&"
import script from "./CreateNewEmployeeForm.vue?vue&type=script&lang=ts&"
export * from "./CreateNewEmployeeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports